// src/PrecioAdmin.js
// Selector de precio para cuando el ADMIN carga una reserva/registro:
// Normal (calculado) · Monto acordado · Sin costo.
import React from "react";

// Monto final según la opción elegida
export function precioFinal(tipo, montoAcordado, normal) {
  if (tipo === "sinCosto") return 0;
  if (tipo === "acordado") return Math.max(0, Number(montoAcordado) || 0);
  return Number(normal) || 0;
}

export default function PrecioAdmin({ tipo, setTipo, monto, setMonto, normal }) {
  return (
    <div className="form-group">
      <label>Precio (solo admin):</label>
      <select value={tipo} onChange={(e) => setTipo(e.target.value)}>
        <option value="normal">{`Normal (UYU ${Number(normal || 0).toLocaleString("es-UY")})`}</option>
        <option value="acordado">Monto acordado</option>
        <option value="sinCosto">Sin costo</option>
      </select>
      {tipo === "acordado" && (
        <input
          type="number"
          min="0"
          step="1"
          placeholder="Monto acordado en UYU"
          value={monto}
          onChange={(e) => setMonto(e.target.value)}
          style={{ marginTop: 6 }}
        />
      )}
    </div>
  );
}
